import React from "react";
import { Body } from "app/_components/components/Text/Body";
import TextLink from "components/parts/NextLink/TextLink";
import { RiskBannerContentWrapper, RiskBannerWrapper } from "../Wrappers";

type MiCARiskBannerProps = {
  id?: string;
};

const MiCARiskBanner = ({ id }: MiCARiskBannerProps) => {
  return (
    <RiskBannerWrapper id={id}>
      <RiskBannerContentWrapper>
        <Body size={"sm"} className={"leading-relaxed md:leading-normal"}>
          Gemini Intergalactic EU Ltd. is authorised by the Malta Financial
          Services Authority as a Crypto-Asset Service Provider.{" "}
          <TextLink href="/legal/gieul-licensing-statement">
            Learn more
          </TextLink>
        </Body>
      </RiskBannerContentWrapper>
    </RiskBannerWrapper>
  );
};

export default MiCARiskBanner;
